interface WaveDividerProps {
  variant?: "liquid" | "fracture" | "diagonal" | "circuit";
  flip?: boolean;
  dark?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export default function WaveDivider({ variant = "liquid", flip = false, dark = false, style: wrapperStyle, className }: WaveDividerProps) {
  const gold = "#D4A843";
  const light = dark ? "rgba(248,244,236,0.15)" : "rgba(212,168,67,0.15)";

  if (variant === "liquid") {
    return (
      <div className={className} style={{ position: "relative", height: 80, overflow: "hidden", transform: flip ? "scaleY(-1)" : undefined, ...wrapperStyle }}>
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" style={{ position: "absolute", width: "200%", height: "100%" }}>
          <path
            d="M0 40 C360 0 720 80 1080 40 C1260 20 1440 60 1440 60 L1440 80 L0 80 Z"
            fill={light}
            style={{ animation: "marqueeLeft 20s linear infinite" }}
          />
        </svg>
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" style={{ position: "absolute", width: "200%", height: "100%" }}>
          <path
            d="M0 50 C240 80 600 10 960 50 C1200 70 1440 30 1440 30 L1440 80 L0 80 Z"
            fill={dark ? "rgba(248,244,236,0.08)" : "rgba(212,168,67,0.08)"}
            style={{ animation: "marqueeRight 25s linear infinite" }}
          />
        </svg>
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" style={{ position: "absolute", width: "200%", height: "100%" }}>
          <path
            d="M0 60 C480 20 960 70 1440 40 L1440 80 L0 80 Z"
            fill={dark ? "rgba(248,244,236,0.04)" : "rgba(212,168,67,0.04)"}
            style={{ animation: "marqueeLeft 18s linear infinite" }}
          />
        </svg>
      </div>
    );
  }

  if (variant === "fracture") {
    return (
      <div className={className} style={{ position: "relative", height: 40, overflow: "hidden", ...wrapperStyle }}>
        <svg viewBox="0 0 1440 40" preserveAspectRatio="none" style={{ width: "100%", height: "100%" }}>
          <path
            d="M0 20 L200 18 L350 22 L500 16 L650 24 L800 19 L950 23 L1100 17 L1250 21 L1440 20"
            fill="none"
            stroke={gold}
            strokeWidth="1.5"
            strokeDasharray="1440"
            strokeDashoffset="1440"
            style={{ animation: "svgDraw 2s ease-out forwards", filter: `drop-shadow(0 0 6px ${gold})` }}
          />
        </svg>
      </div>
    );
  }

  if (variant === "diagonal") {
    return (
      <div className={className} style={{ position: "relative", height: 60, overflow: "hidden", ...wrapperStyle }}>
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" style={{ width: "100%", height: "100%" }}>
          <polygon points="0,60 1440,0 1440,60" fill={dark ? "#050505" : "#0E0E0E"} />
          <polyline points="0,60 1440,0" fill="none" stroke="rgba(212,168,67,0.4)" strokeWidth="1" />
        </svg>
      </div>
    );
  }

  /* circuit */
  return (
    <div className={className} style={{ position: "relative", height: 50, overflow: "hidden", ...wrapperStyle }}>
      <svg viewBox="0 0 1440 50" preserveAspectRatio="none" style={{ width: "100%", height: "100%" }}>
        <path
          d="M0 25 H200 V10 H400 V40 H600 V15 H800 V35 H1000 V20 H1200 V30 H1440"
          fill="none"
          stroke={gold}
          strokeWidth="1"
          strokeDasharray="2000"
          strokeDashoffset="2000"
          opacity="0.4"
          style={{ animation: "svgDraw 3s ease-out forwards" }}
        />
        {[200, 400, 600, 800, 1000, 1200].map((x, i) => (
          <circle
            key={x}
            cx={x}
            cy={i % 2 === 0 ? 10 : 40}
            r="3"
            fill={gold}
            opacity="0"
            style={{ animation: `svgDraw 0.3s ease-out ${1.5 + i * 0.15}s forwards` }}
          />
        ))}
      </svg>
    </div>
  );
}
